<template>
    <div id="bene-mobile-phone-popover-container">
        <f7-popover id="beneMobileNoDropdown" class="popover-mobile-no mobile-country-code beneficiary" :backdrop="true">
            <f7-searchbar id="beneMobileCountryCodeSearch" search-container=".country-code-list" search-in=".country-name" @searchbar:search="onSearch"></f7-searchbar>
              <f7-list class="searchbar-not-found">
                <f7-list-item :title="$t('beneficiary-no-found')"></f7-list-item>
              </f7-list>
              <f7-list class="country-code-list">
                <f7-list-item popover-close link="#" v-for="mIDD in countryCodeList" :key="mIDD.id" @click="changeMobilePhoneCode(mIDD.id)">
                    <img :src="getFlagImg(mIDD.id)" class="mr-sm" loading="lazy"/>
                    <span class="country-name">{{mIDD.name+" "+mIDD.idd}}</span>
                </f7-list-item>
            </f7-list>
        </f7-popover>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'countryCodeList',
            ]),
            ...mapGetters('misc', [
                'latestCountryCodePopoverDirection',
              ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setMobileNo',
                'changeMobilePhoneCode',
                'validateInput'
            ]),

            init() {
                const self    = this;
                const popover = ".beneficiary.popover-mobile-no";
                const popoverInner = ".beneficiary.popover-mobile-no .popover-inner";
                const popoverId = "beneMobileNoDropdown";
                const inputId = "mobileNo";
                const inputListId = "#mobileNoListId";

                self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "beneMobileCountryCode", "beneMobileCountryCodeSearch")
            },

            setInput(inputEl){
                this.$emit("setInput", inputEl);
            },

            onSearch(){
                const self    = this;
                if(self.latestCountryCodePopoverDirection == "above"){
                    const popover = ".beneficiary.popover-mobile-no";
                    const popoverInner = ".beneficiary.popover-mobile-no .popover-inner";
                    const popoverId = "beneMobileNoDropdown";
                    const inputId = "mobileNo";
                    const inputListId = "#mobileNoListId";

                    self.setPopoverPosition(popover, popoverInner, popoverId, inputId, inputListId, "mobile-input", "beneMobileCountryCode", "beneMobileCountryCodeSearch", true)                    
                }
            }
        }
    }
</script>